import { Box, List, ListItem, ListItemIcon, ListItemText, Skeleton } from '@mui/material';
import { YOUTUBE_BROADCAST_THUMBNAIL_WIDTH } from '../shared/consts';

/** Skeleton placeholders shown while recent YouTube broadcasts are loading. */
export function YoutubeBroadcastsLoading() {
  return (
    <List disablePadding>
      {[0, 1, 2].map((i) => (
        <ListItem key={i} disablePadding sx={{ px: 1, py: 1 }}>
          <ListItemIcon sx={{ minWidth: YOUTUBE_BROADCAST_THUMBNAIL_WIDTH, mr: 2 }}>
            <Box
              sx={{ width: YOUTUBE_BROADCAST_THUMBNAIL_WIDTH, aspectRatio: '16/9', flexShrink: 0 }}
            >
              <Skeleton variant="rounded" width="100%" height="100%" />
            </Box>
          </ListItemIcon>
          <ListItemText
            sx={{ my: 0 }}
            primary={<Skeleton width="80%" />}
            secondary={
              <>
                <Skeleton width="60%" />
                <Skeleton width="40%" />
              </>
            }
            secondaryTypographyProps={{ component: 'div' }}
          />
        </ListItem>
      ))}
    </List>
  );
}
